import React from "react";
// import "./BillContent.scss";
// import TtdcLogo from "../../../Images/logo.png";
import TtdcLogo from "../../images/boat/logo.svg";
import errorImg from "../../images/boat/boate.jpg";
import "../../styles/UpiTransaction.scss";
import { subDirectory } from "../../config.json";
import _ from "lodash";
// import errorImg from "../../../Images/error.png";

// import { apiUrl } from "../../../config.json";
import { VscLoading } from "react-icons/vsc";
// import {
//   getUPIData,
//   hotelBooking,
// } from "../../../Services/upiTransactionService";
// import { Loader } from "../../../Components";

import { Loader } from "../common/forms/Loading/Loader";
import { getbookReceiptData } from "../../services/upiService";

class UpiTransaction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      UPIId: "98989898982@paytm",
      paymentUpdated: false,
      error: false,
      loading: false,
    };
  }

  componentDidMount = async () => {
    await this.setState({ loading: true });
    console.log(this.props);
    const { query } = this.getParams(this.props.location.search);
    if (query) {
      const data = query?.split("~");
      const [Payment, BoatHouseId, BookingId] = [...data];
      if (Payment === "Payment") {
        await this.setState({ BoatHouseId: BoatHouseId, BookingId: BookingId });
        await this.getbookreceiptdata();
      } else {
        await this.setState({ error: true });
      }
    } else {
      await this.setState({ error: true });
    }
    await this.setState({ loading: false });
  };

  UPIPaymentHandler = () => {
    const { BookingData, UPIId } = this.state;
    // console.log('UPIIIIII....', this.state.UPIId)
    // console.log('Booking Data....', this.state.BookingData)
    try {
      let TranUpiId = UPIId;
      let TranRefNo = BookingData.BookingId;
      let TranBookingId = BookingData.BookingId;
      let TranName = "Boat"; //
      let Amt = BookingData.InitNetAmount;

      let BoatHouseId = this.state.BoatHouseId; //
      let MobileNo = BookingData.CustomerMobile;
      let EmailId = BookingData.MailId; //not in data
      let UserId = BookingData.CustomerId;
      let BMedia = "PW";
      window.open("intent://play.google.com/store/apps/details?id=com.prematix.upi_lite&launch=true&url-para=upi://pay?pa=" + TranUpiId + "&pn=TTDCBoat&tid=" + TranRefNo + "&tr=" + TranBookingId + "&tn=" + TranName + "&am=" + Amt + "&cu=INR&url=&HotelId=" + BoatHouseId + "&mobileNo=" + MobileNo + "&emailId=" + EmailId + "&userId=" + UserId + "&BookingMedia=" + BMedia + "`#Intent;scheme=https;action=android.intent.action.VIEW;package=com.android.vending;end", "_blank", "height=600, width=400, status=yes, toolbar=no, menubar=no, location=no,addressbar=no");
    } catch (Error) {
      alert("Something Went Wrong! Please Try Again");
    }
  };
  getParams = (search = "") => {
    let queryParams = new URLSearchParams(search);
    console.log({ ...queryParams.entries() });
    return _.fromPairs([...queryParams.entries()]);
  };
  getbookreceiptdata = async () => {
    let data = {
      QueryType: "BoatPrintTicketBulkReceipts",
      ServiceType: "B",
      UserId: "500020",
      BookingDate: "26-02-2021",
      BookingId: "72-39",
      BoatHouseId: "72",
    };

    const res = await getbookReceiptData(data);
    console.log(res);

    if (res.data?.Table.length > 0) {
      await this.setState({ BookingData: res.data.Table[0] });

      console.log(this.state.BookingData);
    } else {
      this.setState({ BookingData: [] });
      await this.setState({ error: true });

      console.log("error");
    }

    console.log(this.state.BookingData);
  };
  //   let urlParams = {};
  //   for (const iterator of new URLSearchParams(
  //     window.location.search
  //   ).entries()) {
  //     urlParams[`${iterator[0]}`] = iterator[1];
  //   }
  //   console.log(urlParams,"URLLLL")
  // console.log(urlParams.query,)

  render() {
    const { UPIData, BookingData, error, loading } = this.state;
    var urlParams = {};
    for (const iterator of new URLSearchParams(window.location.search).entries()) {
      urlParams[`${iterator[0]}`] = iterator[1];
    }
    console.log(urlParams);
    // {
    //   urlParams.PaymentStatus && urlParams.PaymentStatus === "S" && this.state.BookingData?.BookingId && this.state.paymentUpdated === false && this.callUpdateApi();
    // }
    return (
      <>
        <Loader loading={loading} />
        {error ? (
          <>
            <div className="BillPageimg">
              <img src={TtdcLogo} alt="ttdc-logo" className="p-2" style={{ height: "65px", width: "460px" }}></img>
            </div>
            <div className="d-flex flex-column align-items-center mt-5">
              <img src={errorImg} width="30%" height="auto" alt="404" />
              <div className="alert alert-info text-center  font-weight-bold" style={{ width: "50%" }}>
                Details Not Found!...
              </div>
            </div>
          </>
        ) : (
          !loading && (
            <>
              <div className="BillPageimg">
                <img src={TtdcLogo} alt="ttdc-logo" className="p-2" style={{ height: "65px", width: "460px" }}></img>
              </div>
              {urlParams.hasOwnProperty("PaymentStatus") && (
                <>
                  <br />
                  <h2
                    className="text-center mb-1"
                    style={{
                      color: urlParams.PaymentStatus === "S" ? "green" : urlParams.PaymentStatus === "F" ? "red" : "orange",
                    }}
                  >
                    {urlParams.PaymentStatus === "PENDING" && (
                      <>
                        <span className="mr-2">
                          <VscLoading className="paymentLoading" />
                        </span>
                        {urlParams.PaymentStatus}
                      </>
                    )}
                    {urlParams.PaymentStatus === "F" && <div class="alert alert-danger ">Failed! Try Again to Pay</div>}
                    {urlParams.PaymentStatus === "S" && <div class="alert alert-success ">Paid Successfully</div>}
                  </h2>
                </>
              )}
              <div className="BillStyle">
                <h3>{BookingData?.BoatHouseName}</h3>
                <div className="billHeader">
                  <div> Booking Id :{BookingData?.BookingId}</div>
                  <br />
                  <div className="billHeaderRow">
                    <div className="billHeaderRowInner">
                      <span>Booking Date</span>
                      <span>:</span>
                    </div>
                    <div className="timeformat">
                      {BookingData?.BookingDate}
                      {/* {new Date(BookingData?.BookingDate).toLocaleString("en-IN", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                        hour12: "true",
                        minute: "numeric",
                        hour: "numeric",
                      })} */}
                    </div>
                  </div>
                  {BookingData?.CustomerGSTNo ? (
                    <div className="billHeaderRow">
                      <div className="billHeaderRowInner">
                        <span>Customer GSTIN</span>
                        <span>:</span>
                      </div>
                      <div>{BookingData?.CustomerGSTNo} </div>
                    </div>
                  ) : (
                    <div className="billHeaderRow">
                      <div className="billHeaderRowInner">
                        <span> GSTIN</span>
                        <span>:</span>
                      </div>
                      <div>{BookingData?.GSTNumber} </div>
                    </div>
                  )}
                  <div className="billHeaderRow">
                    <div className="billHeaderRowInner">
                      <span>Payment Type</span>
                      <span>:</span>
                    </div>
                    <div> {BookingData?.PaymentTypeName}</div>
                  </div>
                  <div className="billHeaderRow">
                    <div className="billHeaderRowInner">
                      <span>Guest Mobile</span>
                      <span>:</span>
                    </div>
                    <div>{BookingData?.CustomerMobile}</div>
                  </div>
                </div>

                <div className="BillStyle-summary">
                  <table className="table">
                    <thead>
                      <tr>
                        <td colspan={2} style={{ textAlign: "center" }}>
                          <span className="sum">SUMMARY</span>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "left", border: "none" }}>Boat Charges</td>
                        <td className="amtt">₹{BookingData?.InitBoatCharge}</td>
                      </tr>
                      <tr>
                        <td style={{ textAlign: "left" }}>Rower Charges</td>
                        <td className="amtt">₹{BookingData?.InitRowerCharge}</td>
                      </tr>
                      <tr>
                        <td style={{ textAlign: "left" }}>Other Services</td>
                        <td className="amtt">₹{BookingData?.OtherService}</td>
                      </tr>
                      <tr>
                        <td style={{ textAlign: "left" }}>Deposite Amount</td>
                        <td className="amtt">₹{BookingData?.BoatDeposit}</td>
                      </tr>
                      <tr>
                        <td style={{ textAlign: "left" }}>Tax Amount</td>
                        <td className="amtt">₹{BookingData?.TaxAmount}</td>
                      </tr>
                      <tr>
                        <td style={{ textAlign: "left" }}>
                          <span className="sum">Net Amount</span>
                        </td>
                        <td className="amtt">
                          <b>₹{BookingData?.InitNetAmount}</b>
                        </td>
                      </tr>
                      
                    </tbody>
                  </table>
                  {console.log(urlParams.PaymentStatus, urlParams.PaymentStatus === "F", this.state.UPIId)}
                  {(this.state.UPIId != null && urlParams.PaymentStatus ? urlParams.PaymentStatus === "F" : true) && (
                    <div>
                      <button
                        onClick={() => {
                          this.UPIPaymentHandler();
                        }}
                        className="btn btn-success mr-auto ml-auto"
                      >
                        Pay{" "}
                      </button>
                    </div>
                  )}

                  <>
                    {this.state.paymentUpdated === true && (
                      <div class="alert alert-success" role="alert">
                        Payment Updated Successfully
                      </div>
                    )}
                  </>
                </div>
              </div>
            </>
          )
        )}
      </>
    );
  }
}
export default UpiTransaction;
